'use strict';

module.exports = blockquote;

var all = require('../all');
var wrap = require('../wrap');

function blockquote(h, node) {
  return h(node, 'blockquote', wrap(all(h, node)));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/blockquote.js
// module id = 1032
// module chunks = 0